import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import InputMask from 'react-input-mask';
import Select from 'react-select';
import Toggle from 'react-toggle';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';

class FlightTypesEdit extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      id: null,
      name: null,
      abbreviation: null,
      anac_code: null,
      flight_number_required: null,
      exemption_required: false,
      client_required: false,
      maintenance: null,
      charged: null,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.locale = getLocale();

    this.loadData = this.loadData.bind(this);
    this.edit = this.edit.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/tipo/voo/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/tipos/voo');
        if (responseJson.status === 'success') {
          self.setState({
            id: responseJson.data.id,
            name: responseJson.data.name,
            abbreviation: responseJson.data.abbreviation,
            anac_code: responseJson.data.anac_code,
            flight_number_required: responseJson.data.flight_number_required,
            exemption_required: responseJson.data.exemption_required,
            client_required: responseJson.data.client_required,
            maintenance: responseJson.data.maintenance,
            charged: responseJson.data.charged,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      });
    });
  }

  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      name: this.state.name,
      abbreviation: this.state.abbreviation,
      anac_code: this.state.anac_code,
      flight_number_required: this.state.flight_number_required,
      exemption_required: this.state.exemption_required,
      client_required: this.state.client_required,
      maintenance: this.state.maintenance,
      charged: this.state.charged,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/tipo/voo', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }


  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.TiposDeVoo.EditarTipoDeVoo.titulo}</h3>
      <Link to="/tipos/voo" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.edit}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.TiposDeVoo.EditarTipoDeVoo.formulario.Nome}</label>
              <input type="text" name="name" className="form-control" placeholder="" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.TiposDeVoo.EditarTipoDeVoo.formulario.Abreviacao}:</label>
              <input type="text" name="abbreviation" className="form-control" placeholder="" value={this.state.abbreviation} onChange={this.handleChange.bind(this, 'abbreviation')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.TiposDeVoo.EditarTipoDeVoo.formulario.CodigoANAC}:</label>
              <Select
                className="form-field-name"
                name="anac_code"
                value={this.state.anac_code}
                searchable={true}
                placeholder={this.locale.TiposDeVoo.EditarTipoDeVoo.formulario.placeholder.SelecioneCodigo}
                onChange={this.handleSelectChange.bind(this, 'anac_code')}
                options={[
                  {value: "AE", label: "AE"},
                  {value: "CQ", label: "CQ"},
                  {value: "EX", label: "EX"},
                  {value: "NR", label: "NR"},
                  {value: "RE", label: "RE"},
                  {value: "PV", label: "PV"},
                  {value: "SA", label: "SA"},
                  {value: "TN", label: "TN"},
                ]}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.TiposDeVoo.EditarTipoDeVoo.formulario.RequerNumeroDeVoo}?</label>
              <br/>
              <Toggle
                checked={this.state.flight_number_required}
                aria-label='No label tag'
                name="flight_number_required"
                onChange={this.handleToggleChange.bind(this, 'flight_number_required')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.TiposDeVoo.EditarTipoDeVoo.formulario.RequerIsencao}?</label>
              <br/>
              <Toggle
                checked={this.state.exemption_required}
                aria-label='No label tag'
                name="exemption_required"
                onChange={this.handleToggleChange.bind(this, 'exemption_required')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.TiposDeVoo.EditarTipoDeVoo.formulario.ExigeCliente}?</label>
              <br/>
              <Toggle
                checked={this.state.client_required}
                aria-label='No label tag'
                name="client_required"
                onChange={this.handleToggleChange.bind(this, 'client_required')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.TiposDeVoo.EditarTipoDeVoo.formulario.Manutencao}</label>
              <br/>
              <Toggle
                checked={this.state.maintenance}
                aria-label='No label tag'
                name="maintenance"
                onChange={this.handleToggleChange.bind(this, 'maintenance')} />
            </div>
          </div>
          {/* <div className="col-md-6">
            <div className="form-group">
            <label>{this.locale.TiposDeVoo.EditarTipoDeVoo.formulario.Faturado}?</label>
              <br/>
              <Toggle
                checked={this.state.charged}
                aria-label='No label tag'
                name="charged"
                onChange={this.handleToggleChange.bind(this, 'charged')} />
            </div>
          </div> */}
        </div>
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.TiposDeVoo.EditarTipoDeVoo.formulario.botaoEditarTipoDeVoo}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default FlightTypesEdit;



// WEBPACK FOOTER //
// ./src/Components/FlightTypes/FlightTypesEdit.js